import { UsersClient } from '@Clients/UserClient';

/**
 * Fetch the authenticated user's profile. The row (and its personal
 * organization) is created server-side by the `on_auth_user_created` trigger at
 * signup, so it always exists by the time we hold a session.
 */
export const getBaseUser = async (userId: string) => {
  const user = await UsersClient.getUserById(userId);
  if (!user) {
    throw new Error('User profile not found for authenticated session');
  }
  return user;
};
